import { render, staticRenderFns } from "./threePage.vue?vue&type=template&id=28ffbb5b&"
import script from "./threePage.vue?vue&type=script&lang=js&"
export * from "./threePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports